import React, { useState, useEffect } from 'react';
import { Shimmer, TextField } from '@fluentui/react';
import { Color } from '../../const/Const';
import { MessageConst, MessageConstEn } from '../../const/MessageConst';
import NumberFormat from 'react-number-format';

const FieldNumberFormatIncludeZero = (props) => {

    const [value, setValue] = useState();

    const onChanged = (value) => {
        if (value.target.value) {
            let tValue = parseFloat(value.target.value?.toString()?.replaceAll(",", ''));
            setValue(tValue);
            props.onChanged(tValue, '', props.keyfield, '', props.title);
        } else {
            setValue(null);
            props.onChanged(null, '', props.keyfield, '', props.title);
        }
    }

    useEffect(() => {
        setValue(props.defaultValue);
    }, [props.defaultValue]);


    let errorMsg = null;
    if (props.limit && value) {
        if (parseFloat(value?.toString().replaceAll(',', '')) < parseFloat(props.limit.min)
            || parseFloat(value?.toString().replaceAll(',', '')) > parseFloat(props.limit.max)) {
            if (props.lang == "en") {
                errorMsg = 'Limit exceeded';
            } else {
                errorMsg = 'Хязгаараас хэтэрсэн';
            }
        }
    }

    return (
        <div>
            {props.title && (
                <div style={{ display: 'flex' }}>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>
                        {props.title}
                        {props.limit ? (" (" + props.limit.min + "-" + props.limit.max + ")") : null}
                    </div>
                    {props.required && (<div style={{ color: Color.red }}>*</div>)}
                </div>
            )}
            <div style={{ marginTop: props.title ? 6 : 0 }}>
                {props.loading ? (
                    <div>
                        <Shimmer />
                        <Shimmer />
                    </div>
                ) : (
                    <NumberFormat
                        style={{ textAlign: 'end' }}
                        customInput={TextField}
                        onChange={onChanged}
                        thousandSeparator={true}
                        decimalScale={2}
                        disabled={props.disable}
                        value={value ? value : null}
                        errorMessage={(props.required && (value < 0 || value == null || errorMsg) && props.checkreq) ? (errorMsg ? errorMsg : (props.title + (props.lang == "en" ? MessageConstEn.fieldRequired : MessageConst.fieldRequired))) : null}
                        placeholder={props.placeholder}
                    />
                )}
            </div>
        </div>
    );
}

export default FieldNumberFormatIncludeZero;